/* eslint-disable camelcase, no-undef */

// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
const { getElement, getElements, formatMoney } = window.BAO.Utils

const { useArrows } = window.BAO.Carousel.plugins

class productCharms extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.selectors = {
      charm: '[data-product-charm]',
      quantity: '[data-charm-quantity]',
      infoShow: '[data-charm-info-show]',
      charmFilter: '[data-product-charm-filter]',
    }

    this.charms = []
    const defaultMat = []

    this.els.collection.elements.forEach(el => {
      const defaultMatVal = getElement(this.selectors.charmFilter, {
        context: el,
      }).dataset.material

      defaultMat.push(defaultMatVal)
    })

    this.charmFilter = defaultMat
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(this, 'click', this.handleClick)

    this.externalEls.clearAll?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', async () => {
        this.updateCharm(0, 'clearAll')
      })
    })

    this.externalEls.toggle?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', async () => {
        this.toggleCollection(trigger.dataset.collections.split(','))
      })
    })
  }

  toggleCollection (collection) {
    this.els.collection.elements.forEach(el => {
      el.ariaHidden = !collection.includes(el.dataset.collectionId)
    })
  }

  handleClick (e) {
    if (e.target.closest(this.selectors.quantity)) {
      const trigger = e.target.closest(this.selectors.quantity)

      const object = JSON.parse(
        getElement('.var-Charms_Object', {
          context: trigger.closest(this.selectors.charm),
        }).innerText,
      )[0]
      object.text = e.target.closest(this.selectors.charm).dataset.engravingText
      object.font = e.target.closest(this.selectors.charm).dataset.engravingFont
      this.updateCharm(object, trigger.dataset.qtyType)
    }

    if (e.target.closest(this.selectors.infoShow)) {
      const trigger = e.target.closest(this.selectors.infoShow)
      this.infoSlide = trigger.dataset.handle
    }

    if (e.target.closest(this.selectors.charmFilter)) {
      const trigger = e.target.closest(this.selectors.charmFilter)
      const material = trigger.dataset.material
      const index = parseInt(trigger.dataset.index)
      const charmFilter = this.charmFilter
      charmFilter[index] = material

      this.charmFilter = charmFilter
    }
  }

  /**
   *
   * @param {*} value
   */
  async updateCharm (value, action) {
    const matchCurrent = this.charms.filter(obj => obj.id === value.id)

    if (action === 'plus' && matchCurrent.length >= value.max) {
      return
    }

    switch (action) {
      case 'remove':
        this.charms = this.charms.filter((obj, index) => index !== value)
        break
      case 'minus': {
        const removedIndex = this.charms.findLastIndex(
          obj => obj.id === value.id,
        )
        this.charms = this.charms.filter((obj, index) => index !== removedIndex)
        break
      }
      case 'plus':
        this.charms.push(value)
        break
      case 'reorder':
        this.charms = value
        break
      case 'clearAll':
        this.charms = []
        break
    }

    this.externalEls.trigger.element.classList.toggle(
      'prd-DetailVariants_Variant-charmsEdit',
      this.charms.length !== 0,
    )

    const removedDuplicateCharms = [...new Set(this.charms)]

    // Show the qty against each charm
    document.querySelectorAll(this.selectors.charm).forEach(charm => {
      charm.classList.toggle(
        'var-Charms_Product-selected',
        removedDuplicateCharms.some(
          e => e.id === parseInt(charm.dataset.charmId),
        ),
      )
      getElement('.var-Charms_ProductQtyItem-qty', {
        context: charm,
      }).innerHTML = this.charms.filter(
        e => e.id === parseInt(charm.dataset.charmId),
      ).length
    })

    // Show the selected number on the category
    this.els.charm_selected.elements.forEach(charm_selected => {
      charm_selected.ariaHidden = !removedDuplicateCharms.some(
        e => e.category === charm_selected.dataset.category,
      )
      getElement('.var-Charms_HeaderSelectedText', {
        context: charm_selected,
      }).innerHTML = this.charms.filter(
        e => e.category === charm_selected.dataset.category,
      ).length
    })

    // Disable charm on charm inventory
    const matchCurrentNew = this.charms.filter(obj => obj.id === value.id)
    getElements(
      `[data-charm-id="${value.id}"] .var-Charms_ProductQtyItem-plus`,
    ).forEach(charm => {
      charm.classList.toggle(
        'var-Charms_ProductQtyItem-disabled',
        matchCurrentNew.length === value.max,
      )
    })

    let charmIds = ''
    this.charms.forEach(obj => {
      charmIds += `,${obj.variant_id}`
    })
    charmIds = charmIds.slice(1, charmIds.length)
    this.externalEls['charm-ids'].element.value = charmIds

    let charmProductIds = ''
    this.charms.forEach(obj => {
      charmProductIds += `,${obj.id}`
    })
    charmProductIds = charmProductIds.slice(1, charmProductIds.length)
    this.externalEls['charm-product-ids'].element.value = charmProductIds

    let charmText = ''
    this.charms.forEach(obj => {
      charmText += `,${obj.text ? obj.text : '[]'}`
    })
    charmText = charmText.slice(1, charmText.length)
    this.externalEls['charm-engraving-texts'].element.value = charmText

    let charmFonts = ''
    this.charms.forEach(obj => {
      charmFonts += `,${obj.font}`
    })
    charmFonts = charmFonts.slice(1, charmFonts.length)
    this.externalEls['charm-engraving-fonts'].element.value = charmFonts

    this.render()
  }

  /**
   * Charm default filtering
   */
  get charmFilter () {
    return this._charmFilter
  }

  set charmFilter (charmFilter) {
    this.els.collection.elements.forEach((el, i) => {
      const charmFilterValue = charmFilter[i]

      getElements(this.selectors.charmFilter, { context: el })?.forEach(
        filter => {
          filter.classList.toggle(
            'var-Charms_FilterIcon-selected',
            filter.dataset.material === charmFilterValue,
          )
        },
      )

      getElements('.var-Charms_FilterTextActive', { context: el })?.forEach(
        activeText => {
          activeText.innerHTML = charmFilterValue
        },
      )

      getElements(this.selectors.charm, { context: el })?.forEach(charm => {
        charm.ariaHidden = charm.dataset.charmMaterial
          ? charm.dataset.charmMaterial !== charmFilterValue
          : false
      })
    })

    // to sort accordion heights
    window.dispatchEvent(new Event('resize'))

    this._charmFilter = charmFilter
  }

  /**
   * Show/hide the product information
   */
  get infoSlide () {
    return this._infoSlide
  }

  set infoSlide (productHandle) {
    if (productHandle) {
      fetch(`/products/${productHandle}?sections=variant-charm-info`)
        .then(response => response.json())
        .then(responseJSON => {
          getElement('.var-CharmInfo_Target', {
            context: this.externalEls.info.element,
          }).innerHTML = responseJSON['variant-charm-info']

          this.initialiseInfoCarousel()
        })
        .catch(e => {
          console.error(e)
        })
    }

    this._infoSlide = productHandle
  }

  initialiseInfoCarousel () {
    if (this.externalEls['info-slider']) {
      return new KeenSlider(
        this.externalEls['info-slider'].element,
        {
          selector: this.externalEls['info-slide'].elements,
          loop: true,
          slides: {
            origin: 'center',
            perView: 1,
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          useArrows({
            next: this.externalEls['info-next'].element,
            previous: this.externalEls['info-previous'].element,
          }),
        ],
      )
    }
  }

  render () {
    let html = ``
    let priceTotal = 0
    for (let index = 0; index < this.charms.length; index++) {
      const element = this.charms[index]
      let lines = []

      if (element.text) {
        const engravingText = JSON.parse(element.text)

        for (const pair of engravingText) {
          lines = [...lines, pair[1]]
        }
      }

      html += `<div class="prd-VariantCharm_Item">
        <img class="prd-VariantCharm_ItemImage" src="${
          element.image
        }" width="60" height="60"/>

        <div class="prd-VariantCharm_ItemContent">
          <p class="prd-VariantCharm_ItemTitle fz-11_155">${element.name}</p>

          <p class="prd-VariantCharm_ItemPrice fz-11_155">
            +${formatMoney(element.price)}${
        element.text
          ? `, Free Engraving added! "${lines}" <span class='prd-VariantCharm_ItemEdit' data-drawers-trigger="${element.id}-engraving">Edit</span>`
          : ''
      }
          </p>
        </div>

        <div class="prd-VariantCharm_ItemRemove" data-product-charms-external-el="remove" data-index="${index}">
          <svg viewBox="0 0 17 17" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 16L16 1" />
            <path d="M16 16L1 1" />
          </svg>
        </div>
      </div>`

      priceTotal = priceTotal + element.price
    }

    this.externalEls.target.element.innerHTML = html
    this.externalEls.items.element.innerText = this.externalEls.items.element.dataset.template
      .replace('[[ count ]]', this.charms.length)
      .replace('[[ price ]]', formatMoney(priceTotal))

    this.renderListeners()
  }

  renderListeners () {
    this.externalEls.remove?.elements.forEach(trigger => {
      this.listeners.add(trigger, 'click', async () => {
        this.updateCharm(parseInt(trigger.dataset.index), 'remove')
      })
    })
  }
}

if (!customElements.get('product-charms')) {
  customElements.define('product-charms', productCharms)
}
